// True when the app is being served from the CaddieGames custom domain
// (e.g. app.caddiegames.com). The AskSmart and CaddieGames front ends are the
// same Static Web App bundle on two domains; this lets the shared root route
// pick the CaddieGames login/auth experience by hostname. Matches the apex and
// any subdomain so an accidental www/apex hit still routes correctly. Returns
// false for localhost / asksmart.ai so those keep the AskSmart experience.
export function isCaddieGamesHost(hostname?: string): boolean {
  const raw = hostname ?? (typeof window === "undefined" ? "" : window.location.hostname);
  const host = raw.toLowerCase();
  return host === "caddiegames.com" || host.endsWith(".caddiegames.com");
}
